module.exports = __webpack_public_path__ + "static/media/dotted-arrow-large.26d6601c.svg";